import React from 'react'

import FortnoxStatusBanner from 'components_new/organisms/FortnoxStatusBanner'
import HomeHeader from 'components_new/organisms/HomeHeader'
import HomeOverview from 'components_new/organisms/HomeOverview'
import HomeGroupPreviews from 'components_new/organisms/HomeGroupPreviews'
import HomeQuickLinks from 'components_new/organisms/HomeQuickLinks'
import ObjectRowTypesBanner from 'components_new/organisms/ObjectRowTypesBanner'

import PageLayout from 'components_new/templates/PageLayout'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

const Home = () => {
  const { isAdmin, isCompanyGroup } = useAccountSettings()
  const { t } = useTranslation()

  return (
    <PageLayout
      footer={{
        mobile: {
          showNavigation: true
        }
      }}
      topbar={{
        breadcrumbs: [{ title: t('global', 'home') }]
      }}
      variant="feed"
    >
      <FortnoxStatusBanner />
      {isAdmin ? <ObjectRowTypesBanner /> : null}
      <HomeHeader sx={{ mb: 4 }} />
      <HomeOverview sx={{ mb: 8 }} />
      {/* Company group user should not be able to see groups.*/}
      {isCompanyGroup ? null : <HomeGroupPreviews />}
      <HomeQuickLinks />
    </PageLayout>
  )
}

export default Home
